import React from "react";
import ReactDOM from "react-dom";
import "./fonts/style.css";
import "./globals.css";
import "./telmo-chatbot.css";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { createBrowserHistory } from "history";

(window as any).TALMACLICK_VERSION = "v0.31.0";

const history = createBrowserHistory();

const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1];
if (path) {
  history.replace(path);
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
